import $ from 'jquery';

export default class TemplatePassword {
  constructor({ el }) {
    this.$el = $(el);
    this.togglePasswordForm = this.togglePasswordForm.bind(this);
    this.toggle = $('.password-entry', this.$el);
    this._bindEvents();
    if ($('[data-password-form-inner]', this.$el).hasClass('has-errors')) {
      this.togglePasswordForm();
    }
  }

  _bindEvents() {
    this.events = [
      this.toggle.on('click.password', this.togglePasswordForm),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.password'));
  }

  togglePasswordForm() {
    $('.password-subscribe-wrapper', this.$el).add('.password-form-wrapper').toggleClass('visible');

    if ($('.password-subscribe-wrapper', this.$el).hasClass('visible')) {
      this.toggle.text(this.toggle.data('enter-password'));
    } else {
      this.toggle.text(this.toggle.data('cancel'));
    }
  }

  onSectionUnload() {
    this._unbindEvents();
  }
}
